export let xavis_experiments = false;

export function setXavisExperiments(enabled: boolean) {
    xavis_experiments = enabled;
    document.body.classList.toggle('y-xavi', enabled);
}

export const $debug: { [key: string]: any } = {};

export type YLogScope = 'app' | 'gc' | 'worker' | 'selection' | 'editable' | 'navigation' | 'analytics' | 'http' | 'socket' | 'callback' | 'errors' | 'layout' | 'player' | 'editor' | 'screen' | 'buola' | 'forced' | 'table';

export function $log(scope: YLogScope, format: string, ...args: any[]) {
    if(xavis_experiments && $log.scopes[scope])
        console.log(`%c${scope}: %c${format}`, 'font-weight:bold', 'color: #aaa', ...args);
}

export namespace $log {
    const marks: Record<string, number> = {};

    export function tick(name: string) {
        marks[name] = performance.now();
    }

    export function tock(scope: YLogScope, name: string) {
        const now = performance.now();
        const prev = marks[name];
        if(prev != null)
            $log(scope, `%c${name}: %c${(now - prev).toFixed(2)}ms`, 'font-weight:bold', '');
    }

    export function busyWait(w: number = 0.01) {
        w = w * 1000;
        const t = performance.now();
        while(performance.now() - t < w);
    }

    export const scopes: { [key in YLogScope]?: boolean } = {
        forced: true,
        app: true,
        // editable: true,
        errors: true,
        screen: true,
        buola: true,
        // table: true,
        // gc: true
    };

    export const RED = 'color: #E13F3F';
    export const GREEN = 'color: #5BC685';
    export const BLUE = 'color: #66ACFF';
    export const PURPLE = 'color: #A087E8';
    export const ORANGE = 'color: #FFA566';
}

let report_crashes = 3;

export function yEnableCrashReports(count: number = 1) {
    report_crashes = count;
}

interface ErrorInfo {
    url: string;
    message: string;
    stack: string;
    cause: string;
}

const crash_callbacks: ((info: ErrorInfo) => void)[] = [];

export function yAddCrashCallback(cb: (info: ErrorInfo) => void) {
    crash_callbacks.push(cb);
}

export function yReportCrash(message: string, cause: string) {
    if(report_crashes > 0) {
        report_crashes--;

        for(const cb of crash_callbacks) {
            cb({ url: window.location.href, message: message, stack: '<unknown>', cause: cause });
        }
    }
}

window.onerror = (message, filename, lineno, colno, error) => {
    if(message === 'ResizeObserver loop limit exceeded') return;

    if(report_crashes > 0) {
        report_crashes--;

        let cause: string;
        let stack: string;

        if(typeof error == 'string') {
            stack = '<promise>';
            cause = error;
        } else {
            stack = (error && error.stack && typeof error.stack === 'string') ? error.stack : filename + ', ' + lineno + ':' + colno;
            cause = (error?.name) || 'Unknown';
        }

        for(const cb of crash_callbacks) {
            cb({ url: window.location.href, message: message + '', stack: stack, cause: cause });
        }
    }
};

window.addEventListener('unhandledrejection', ev => {
    $log('errors', 'Unhandled promise', ev);
    // window.onerror('Error in promise', '-', 0, 0, JSON.stringify(ev.reason) as any);
});
